import { NgxLoadingComponent, ngxLoadingAnimationTypes } from 'ngx-loading';
import { Common } from './../studentregistration/Common';
import { ReturnStatus } from './../class/return-status';
import { StudentevaluationService } from './../service/studentevaluation.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, ViewChild, TemplateRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { JilabaAesED } from '../common/JilabaAesED';
import { JilabaKeyEnum } from '../common/JilabaKeyEnum';

const PrimaryRed = '#dd0031';
const SecondaryBlue = '#006ddd';

@Component({
  selector: 'app-downloadpdf',
  templateUrl: './downloadpdf.component.html',
  styleUrls: ['./downloadpdf.component.css']
})
export class DownloadpdfComponent {


  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public loading = false;
  public primaryColour = PrimaryRed;
  public secondaryColour = SecondaryBlue;
  public coloursEnabled = false;
  public loadingTemplate: TemplateRef<any>;
  public config = { animationType: ngxLoadingAnimationTypes.none,
  primaryColour: this.primaryColour, secondaryColour: this.secondaryColour,
  tertiaryColour: this.primaryColour, backdropBorderRadius: '3px' };
  mobileno: string;
  returnstatus: ReturnStatus;
  regnoarray: Array<string> = new Array<string>();
  regno: string;

  constructor(public dialog: MatDialog,  public dialogRef: MatDialogRef<DownloadpdfComponent>,
    public snackBar: MatSnackBar, private studentservice: StudentevaluationService, private spinner: NgxSpinnerService) { }

  close(): void {
    this.dialogRef.close(null);
  }

  mobilenovalidation() {
    if (this.mobileno !== undefined && this.mobileno !== null) {
      if (this.mobileno.toString().length !== 10) {
        document.getElementById('txtmobno').focus();
        this.snackBar.open('' + this.mobileno, 'Enter valid Mobileno', {
          duration: 2000,
        });
      } else {
        this.loadregno();
      }
    }
  }

  loadregno() {

    let map:any={
      "mobileno":this.mobileno,
      "tocken":JilabaAesED.Encrypt(this.mobileno,JilabaKeyEnum.CommonKey)
    }

    this.studentservice.loadregno(map).subscribe(data => {
        this.returnstatus = data;
        if (this.returnstatus.status === true) {
            this.regnoarray = this.returnstatus.returnObject;
            if (this.regnoarray.length > 0) {
              this.regno = this.regnoarray[0];
              document.getElementById('btnpdf').focus();
            } else {
              this.close();
              alert('Mobile Number not registered...Please fill your Registration Details as New User');
            }
        } else {
          alert(this.returnstatus.description);
        }
    });
  }

  async downloadPDF() {
    this.spinner.show();
    if (this.regno === undefined || this.regno === null || this.regno === '') {
      document.getElementById('txtregno').focus();
      this.snackBar.open('', 'Please Enter Mobile Number !!', {
        duration: 2000,
      });
      this.spinner.hide();
  } else {
    await this.loadPDF(this.regno);
    this.spinner.hide();
  }

  }

  async loadPDF(studno: string) {
    let map:any={
      "studno":studno,
      "tocken":JilabaAesED.Encrypt(studno,JilabaKeyEnum.CommonKey)
    }
    await this.studentservice.loadpdf(map).then( data => {
       this.returnstatus = data;
       if (this.returnstatus.status === true) {
         this.loading = true;
         const map: any = this.returnstatus.returnObject;
         alert('Kindly fill and carry both the documents with you when attending the examination. They are required to be filled and kept ready');
         Common.loadPdf(map['byteData'], studno);
        //  Common.createPDF(studno, map['clgName'],map['studentName']);        
         this.loading = false;
         this.close();
       } else {
         alert (this.returnstatus.description);
       }
    });
  }

}
